export default __webpack_public_path__ + "static/media/lisieux02.5280397f.jpg";